import { dummyCaptains } from "src/constants/dummyCaptains";
import instance from "..";
import { createQueryString } from "src/utils/helper";
import { setCaptainsList } from "src/reducers/captains";

// ✅ GET CAPTAINS LIST
export const getCaptainsListAction: any =
  (apiData) => async (dispatch: any) => {
    try {
      const query = createQueryString(apiData);

      const res = await instance.get(
        `/api/v1/admin/captains?${query}`
      );

      const apiResponse = res?.data;

      if (
        !apiResponse?.success ||
        !apiResponse?.data ||
        !apiResponse?.data?.data
      ) {
        dispatch(setCaptainsList(dummyCaptains));
        return dummyCaptains;
      }

      // ✅ 🔥 IMPORTANT MAPPING FOR UI COMPATIBILITY
      const formattedData = {
        result: {
          data: apiResponse.data.data.map((item: any) => ({
            id: item.id,

            // ✅ MATCH UI
            name: item.fullName,
            phone: item.phone,
            createdAt: new Date(item.createdAt).toLocaleString(),

            // ✅ UI expects number (1/0)
            status: item.isActive ? 1 : 0,

            imageUrl: item.imageUrl,

            // ✅ vehicles (expandable table)
            vehicles:
              item.vehicles?.map((v: any) => ({
                registrationNumber: v.registrationNumber,
                model: v.model,
                color: v.color,
                seatCapacity: v.seatCapacity,
                insuranceExpiry: v.insuranceExpiry,
                pollutionExpiry: v.pollutionExpiry,
              })) || [],

            // ✅ documents (dialog)
            documents: item.documents || [],
          })),
          total: apiResponse.data.total,
        },
      };

      dispatch(setCaptainsList(formattedData));
      return formattedData;
    } catch (err) {
      console.log("🔥 Using dummy captains");
      dispatch(setCaptainsList(dummyCaptains));
      return dummyCaptains;
    }
  };

// ✅ UPDATE STATUS
export const updateCaptainStatusAction: any =
  (payload) => async () => {
    try {
      const res = await instance.put(
        `/api/v1/admin/users/${payload.id}/toggle-status`
      );
      return res.data;
    } catch (err: any) {
      throw err?.response?.data || err;
    }
  };

// ✅ DELETE
export const deleteCaptainAction: any =
  (id) => async () => {
    try {
      const res = await instance.delete(
        `/api/v1/admin/captains/${id}`
      );
      return res.data;
    } catch (err: any) {
      throw err?.response?.data || err;
    }
  };

// ✅ DOCUMENT STATUS
export const updateDocumentStatusAction: any =
  (payload) => async () => {
    try {
      const res = await instance.patch(
        `/api/v1/admin/captains/document/status`,
        payload
      );
      return res.data;
    } catch (err: any) {
      throw err?.response?.data || err;
    }
  };